import { Navigate } from 'react-router-dom'
import { Spinner } from '@/components/ui'
import { useSetupDrafts } from '@/features/setup-wizard/hooks/useSetupWizard'
import { draftSetupPath, sortDraftsByRecency } from '../utils/setupDraft'

const NEW_SETUP_PATH = '/companies/setup-wizard/drafts/new'

/**
 * Where the "Setup Wizard" nav link lands: the unfinished setup the user
 * last worked on, or a new one. (It used to redirect to the companies list.)
 */
export function SetupWizardEntry(): React.ReactElement {
  const drafts = useSetupDrafts()

  if (drafts.isLoading) {
    return (
      <div className="flex justify-center py-16" aria-label="Opening setup wizard">
        <Spinner />
      </div>
    )
  }

  // If the drafts cannot be read, starting a new setup is still the right page.
  const latest = drafts.isError ? undefined : sortDraftsByRecency(drafts.data ?? [])[0]
  return <Navigate to={latest ? draftSetupPath(latest) : NEW_SETUP_PATH} replace />
}

SetupWizardEntry.displayName = 'SetupWizardEntry'
